<template>
    <div style="height: 100%; overflow-y: auto">
        <b-tabs fill v-model="tabIndex" @input="onInputTabs" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px">
            <b-tab title="Consenso">
                <div class="sa-flexbox">
                    <div class="sa-flexbox-body">
                        <div class="sa-flexbox-body-content">
                            <tiny-mce-edit-component ref="cmpTinyMceEditComponent" @updateContent="onUpdateContentTinyMceEditComponent"></tiny-mce-edit-component>
                        </div>
                        <div class="sa-flexbox-body-right" style="width: var(--sidebar-width)">
                            <b-tabs nav-wrapper-class="sa-tab-items" content-class="mt-3" ref="tabs" class="sa-tab" fill style="height: 100%; padding-bottom: 25px">
                                <b-tab title="Informazioni" style="overflow-x: hidden">
                                    <div style="display: flex; flex-direction: column">
                                        <b-row>
                                            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <label class="sa-label-data">Struttura:</label>
                                                <b-form-select v-model="jsonData.codiceStruttura" :options="strutturaOptions" value-field="codiceStruttura" text-field="denominazione">
                                                    <template #first>
                                                        <b-form-select-option :value="null" disabled>Seleziona</b-form-select-option>
                                                    </template>
                                                </b-form-select>
                                            </b-col>
                                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                                <label class="sa-label-data">Nome:</label>
                                                <b-form-input v-model="jsonData.nomeConsenso"></b-form-input>
                                            </b-col>
                                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                                <label class="sa-label-data">Sezione:</label>
                                                <b-form-select v-model="jsonData.sezione" :options="sezioniOptions" value-field="codice" text-field="descrizione">
                                                    <template #first>
                                                        <b-form-select-option :value="null" disabled>Seleziona</b-form-select-option>
                                                    </template>
                                                </b-form-select>
                                                <!-- <b-form-input v-model="jsonData.sezione"></b-form-input> -->
                                            </b-col>
                                            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <label class="sa-label-data">Stato Attuale:</label>
                                                <b-form-select v-model="jsonData.statoAttuale" :options="statiOptions" value-field="value" text-field="text">
                                                    <!-- <template #first>
                                                        <b-form-select-option :value="null" disabled>Seleziona</b-form-select-option>
                                                    </template> -->
                                                </b-form-select>
                                                <!-- <b-form-input v-model="jsonData.sezione"></b-form-input> -->
                                            </b-col>
                                            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <label class="sa-label_data">Data Ora</label>
                                                <date-picker disabled v-model="jsonData.statoAttualeDataOra" format="DD-MM-YYYY HH:mm" value-type="timestamp" type="datetime"></date-picker>
                                            </b-col>
                                            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <label class="sa-label-data">Tipologia:</label>
                                                <b-form-select v-model="jsonData.tipologia">
                                                    <template #first>
                                                        <b-form-select-option :value="null" disabled>Seleziona</b-form-select-option>
                                                    </template>
                                                    <b-form-select-option :value="'FACOLTATIVO'">FACOLTATIVO</b-form-select-option>
                                                    <b-form-select-option :value="'OBBLIGATORIO'">OBBLIGATORIO</b-form-select-option>
                                                </b-form-select>
                                            </b-col>
                                            <b-col cols="4" v-for="(item, index) of Object.keys(this.margini)" :key="index">
                                                <label class="sa-label-data"> {{ item }}</label>
                                                <b-form-input v-model="margini[item]" type="number" min="0"></b-form-input>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </b-tab>
                                <b-tab title="Tags">
                                    <b-tabs fill end>
                                        <b-tab title="Selezionati">
                                            <div style="height: 500px; margin-top: 12px; overflow-y: scroll">
                                                <template v-if="tagsSelezionati.length > 0">
                                                    <div :class="{ 'sa-badge': true }" style="width: 100%" v-for="(tag, index) of tagsSelezionati" :key="index">
                                                        <div class="sa-badge-label">{{ tag.tag }}</div>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div class="sa-badge-label">Nessun Tag Selezionato</div>
                                                </template>
                                            </div>
                                        </b-tab>
                                        <b-tab title="Caricati">
                                            <div style="height: 500px; margin-top: 12px; overflow-y: scroll">
                                                <template v-if="tagsItems.length > 0">
                                                    <div v-for="(tag, index) of tagsItems" :key="index" :class="{ 'sa-badge': true, 'ft-draggable-block': true }" @dragstart="onDragStart(tag, $event)" draggable="true" style="width: 100%">
                                                        <div class="sa-badge-label">{{ tag.tag }}</div>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div class="sa-badge-label">Nessun Tag Caricato</div>
                                                </template>
                                                <hr />
                                                <span>Default Tags</span>
                                                <hr />
                                                <template>
                                                    <div v-for="(deafultTags, deafultTagsIndex) of defaultTagsItems" :key="deafultTags.nome + deafultTagsIndex" :class="{ 'sa-badge': true, 'ft-draggable-block': true }" @dragstart="onDragStart(deafultTags, $event)" draggable="true" style="width: 100%">
                                                        <div class="sa-badge-label">{{ deafultTags.tag }}</div>
                                                    </div>
                                                </template>
                                                <!-- <div :class="{ 'sa-badge': true, 'ft-active-class': isActiveTag(tag), 'ft-active-selected': isSelectedTag(tag) }" @click="onSelezionaTag(tag)" style="width: 100%" v-for="(tag, index) of tagsItems" :key="index">
                    <div class="sa-badge-label">{{ tag.tag }}</div>
                  </div> -->
                                            </div>
                                        </b-tab>
                                    </b-tabs>
                                </b-tab>
                            </b-tabs>
                        </div>
                    </div>
                </div>
            </b-tab>
            <b-tab title="Prewiew">
                <div v-if="pdfViewer != null" style="padding: 5px; display: flex; justify-content: center; width: 100%; height: 100%; padding-bottom: 20px; padding-left: 10px; padding-right: 10px">
                    <b-embed type="iframe" v-show="showPdf" :src="pdfViewer" allowfullscreen></b-embed>
                </div>
                <div v-else style="display: flex; align-items: center; text-align: center; justify-content: center; height: 100%">
                    <div class="sa-badge-large">Pdf non ancora disponibile, riprovare la preview</div>
                </div>
            </b-tab>
            <b-tab title="JSON">
                <b-row>
                    <b-col cols="9">
                        <label class="sa-label-data">Json di Riferimento <font-awesome-icon icon="times-circle" style="color: #c82333 !important" v-if="jsonError" /> <font-awesome-icon style="color: #218838 !important" icon="check-circle" v-else /></label>
                        <b-form-textarea v-model="jsonData.dataModel" no-resize rows="30"></b-form-textarea>
                    </b-col>
                    <b-col cols="3">
                        <div style="height: 500px; margin-top: 12px; overflow-y: scroll">
                            <template v-if="tagsItems.length > 0">
                                <label class="sa-label-data">Tags Caricati</label>
                                <div :class="{ 'sa-badge': true, 'ft-draggable-block': true }" @dragstart="onDragStart(tag, $event)" draggable="true" style="width: 100%" v-for="(tag, index) of tagsItems" :key="index">
                                    <div class="sa-badge-label">{{ tag.tag }}</div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="sa-badge-label">Nessun Tag Caricato</div>
                            </template>
                        </div>
                    </b-col>
                </b-row>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import axios from "axios";
import DatePicker from "vue2-datepicker";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
import UtilityMixin from "../../utility/UtilityMixin";
import TinyMceEditComponent from "../../utility/components/TinyMceEditComponent.vue";
export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    components: { TinyMceEditComponent, DatePicker },
    mixins: [UtilityMixin, StruttureMixin],
    data() {
        return {
            id: "-1",
            margini: {
                margini: 0,
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
            },
            showPdf: false,
            pdfViewer: null,
            caricaTagsBtn: false,
            allMargini: true,
            statiOptions: [
                { value: null, text: "-Seleziona Valore-" },
                { value: "ATTIVO", text: "ATTIVO" },
                { value: "DEPRECATO", text: "DEPRECATO" },
            ],
            jsonData: {
                nomeConsenso: "",
                statoAttuale: "ATTIVO",
                statoAttualeDataOra: new Date().getTime(),
                tipologia: null,
                reportName: "",
                sezione: null,
                descrizione: "",
                codiceStruttura: null,
                testoConsenso: null,
                dataModel: "",
                margini: "",
            },
            tabIndex: 0,
            jsonError: false,
            tagsNonPresenti: [],
            tagsItems: [],
            tagsSelezionati: [],
            tagSelezionato: null,
            pathResourceTag: "/consensitag",
            pathResource: "/consensi",
            content: "",
            linkStrutture: "/strutture",
            pathResourceSezioni: "/consensisezioni",
            strutturaOptions: [],
            sezioniOptions: [],
            tag: {
                nome: "",
                note: null,
                tag: "",
            },
            defaultTagsItems: [
                { nome: "sigAssistito", tag: "${sigAssistito}" },
                { nome: "sigPaziente", tag: "${sigPaziente}" },
                { nome: "sigOspite", tag: "${sigOspite}" },
                { nome: "sig", tag: "${sig}" },
                { nome: "data", tag: "${data}" },
                { nome: "dataOra", tag: "${dataOra}" },
            ],
            draggedElementTag: null,
        };
    },
    watch: {
        magini(value) {
            console.log(value);
        },
        content(newVal) {
            this.jsonData.testoConsenso = newVal;
            if (this.id != "-1") {
                this.setTagSelezionati();
            }
        },
        "jsonData.dataModel": function (params) {
            let me = this;
            try {
                JSON.parse(params);
                me.jsonError = false;
                me.caricaTagsBtn = true;
            } catch (e) {
                me.jsonError = true;
                me.caricaTagsBtn = false;
            }
        },
    },
    computed: {},
    mounted() {
        this.loadStrutture();
        this.loadSezioni();
        this.id = this.$route.params.id;
        this.tagsItems = [];
        if (this.id != "-1") {
            this.loadConsenso();
        }
    },
    methods: {
        // init(jsonData) {
        // 	if (jsonData) {
        // 		this.jsonData = JSON.parse(JSON.stringify(jsonData));
        // 		this.content = this.jsonData.testoConsenso;
        // 	}
        // 	if (this.id != "-1") {
        // 		this.setTagSelezionati();
        // 		this.setMargini();
        // 	} else {
        // 		this.resetjsonData();
        // 		this.setDatiStruttura();
        // 	}
        // },
        getConsenso() {
            return this.jsonData;
        },
        loadConsenso() {
            this.openShowModalLoading();
            UtilityMixin.methods.loadDataResources("/consensi/" + this.id, {}, this.loadConsensoSuccess, this.loadConsensoError);
        },

        loadConsensoSuccess(response) {
            this.jsonData = response.data.data;
            this.$refs.cmpTinyMceEditComponent.setContent(this.jsonData.testoConsenso);
            this.setTagSelezionati();
            this.setMargini();
            this.setTags();
            this.closeShowModalLoading();
        },
        loadConsensoError(error) {
            console.log(error);
            this.closeShowModalLoading();
        },
        onEditInit(event) {
            console.log(event);
        },
        onInputTabs(tab) {
            this.$emit("inputTab", tab);
        },
        onDragStart(item, event) {
            console.log(item);

            this.draggedElementTag = item;
            event.dataTransfer.setData("text/html", `<span class="inserted-tag">${item.tag}</span>`);
        },
        getLabelMargine(labelMargine) {
            let returnValue = labelMargine.replace("margine", "");
            if (returnValue == "") {
                returnValue = "All";
            }
            return returnValue;
        },
        onClickSetTags() {
            this.tagsItems = [];
            if (!this.jsonError) {
                this.setTags(null, null);
            }
        },
        onClickPreview() {
            let item = {
                idConsenso: this.jsonData.id,
                data: this.jsonData.dataModel,
            };
            this.openShowModalLoading();
            axios
                .post(process.env.VUE_APP_PATH_API + this.pathResource + "/create", item)
                .then((response) => {
                    this.closeShowModalLoading();
                    console.log(response);
                    this.$bvToast.toast("Preview Caricata con successo", {
                        title: "Operazione Avvenuta con Successo",
                        variant: "success",
                        solid: true,
                    });

                    this.pdfViewer = "data:application/pdf;base64," + response.data.data;
                    this.showPdf = true;
                })
                .catch((err) => {
                    this.closeShowModalLoading();
                    this.$bvToast.toast(err.response.data.messaggio, {
                        title: "Attenzione",
                        variant: "danger",
                        solid: true,
                    });
                    console.log(err);
                });
        },

        setTags(data, keyf) {
            let json = {};
            if (!data) {
                json = JSON.parse(this.jsonData.dataModel);
            } else {
                json = JSON.parse(data);
            }
            for (let key of Object.keys(json)) {
                let tag = "";
                if (!keyf) {
                    tag = "$".concat("{").concat(key).concat("}");
                } else {
                    tag = "$".concat("{").concat(keyf).concat(".").concat(key).concat("}");
                }

                if (typeof json[key] != "object") {
                    this.tagsItems.push({ tag: tag });
                }
                if (json[key] && typeof json[key] === "object") {
                    this.setTags(JSON.stringify(json[key]), key);
                }
            }
            // if (this.tagsItems.indexOf({ tag: "${`sign`}" }) == -1) {
            // 	console.log("creazione tag ${sign}");

            // 	this.tagsItems.push({ tag: "${`sign`}" });
            // }
        },
        setMargini() {
            //esempio 5,5,5,5 se sono 4 significa che devo valorizzare in ordine top,bottom,left,right se invece il valore è unico margini:1.
            if (this.jsonData.margini.includes(",")) {
                let margini = this.jsonData.margini.split(",");
                let cardinals = Object.keys(this.margini);
                cardinals.splice(0, 1);
                for (let margine in margini) {
                    this.margini[cardinals[margine]] = margini[margine];
                }
            } else {
                this.margini.margini = this.jsonData.margini;
            }
        },
        linkClass(idx) {
            if (this.tabIndex === idx) {
                return ["bg-primary", "text-light"];
            } else {
                return ["bg-light", "text-info"];
            }
        },
        setTagSelezionati() {
            this.tagsSelezionati = [];
            if (this.jsonData.testoConsenso) {
                const risultati = this.jsonData.testoConsenso.match(/\${.*?}/g);
                if (risultati)
                    for (let risultato of risultati) {
                        this.tagsSelezionati.push({ tag: risultato, testo: true });
                    }
            }
        },
        isSelectedTag(tag) {
            if (this.tagSelezionato != null) {
                if (this.tagSelezionato == tag) {
                    this.tagSelezionato = null;
                } else {
                    this.tagSelezionato = tag;
                }
                return false;
            }
        },
        onSelezionaTag(tag) {
            if (this.isActiveTag(tag)) {
                return;
            }
            console.log(tag, "tag");
        },
        resetjsonData() {
            this.jsonData = {
                nomeConsenso: "",
                tipologia: null,
                reportName: "",
                sezione: "",
                descrizione: "",
                codiceStruttura: null,
                testoConsenso: "",
            };
        },
        isActiveTag(tag) {
            const index = this.tagsSelezionati.findIndex((e) => e == tag.tag);
            if (index == -1) {
                this.tagsNonPresenti.push(tag);
            }

            return index == -1 ? false : true;
        },
        saveResource() {
            let result = "";
            if (this.margini.margini != "") {
                result = this.margini.margini;
            } else {
                let cardinals = Object.keys(this.margini);
                cardinals.splice(0, 1);
                result = cardinals.map((c) => this.margini[c]).join(",");
                console.log(result);
            }
            this.jsonData.margini = result;
            UtilityMixin.methods.saveResource(this.pathResource, this.jsonData, this.onSaveCloseSuccess, this.onSaveCloseError);
        },

        onSaveCloseSuccess(response) {
            console.log(response);
            this.$router.back();
        },
        onSaveCloseError(error) {
            error;
        },
        loadStrutture() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.linkStrutture, null, me.loadStruttureSuccess, me.loadStruttureError);
        },
        loadStruttureSuccess(response) {
            let me = this;
            me.strutturaOptions = [];
            me.strutturaOptions = response.data.data;
        },
        loadStruttureError(error) {
            error;
        },
        loadSezioni() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSezioni, null, me.loadSezioniSuccess, me.loadSezioniError);
        },
        loadSezioniSuccess(response) {
            let me = this;
            me.sezioniOptions = [];
            me.sezioniOptions = response.data.data.list;
            if (me.sezioniOptions.length === 1) {
                me.jsonData.sezione = me.sezioniOptions[0].codice;
            }
        },
        loadSezioniError(error) {
            error;
        },

        onClickFormattaJson() {
            let formatt = JSON.stringify(JSON.parse(this.jsonData.dataModel), null, 4);
            this.jsonData.dataModel = formatt;
        },
        setDatiStruttura() {
            let tmpPresidio = window.localStorage.getItem("presidio");
            //console.log(tmpPresidio);

            if (tmpPresidio) {
                this.presidio = JSON.parse(tmpPresidio);
                this.strutturaLoadDataByCodiceCallBack(this.presidio.codiceStruttura, this.onCallBackDatiStruttura);
            }
        },
        onCallBackDatiStruttura(struttura) {
            this.jsonData.codiceStruttura = struttura.codiceStruttura;
        },
        onUpdateContentTinyMceEditComponent(content) {
            this.jsonData.testoConsenso = content;
        },
    },
};
</script>

<style scoped>
.sa-flexbox-body {
    height: 50px;
    flex: 1;
    display: flex;
    flex-direction: row;
    overflow: hidden;
}

.sa-badge {
    max-width: none !important;
    cursor: pointer;
}

.sa-badge-large {
    font-size: medium;
    border-radius: 5px;
    border-left: 4px solid #d8e280;
    border-top: 1px solid var(--bg-main-nav-bar);
    border-bottom: 1px solid var(--bg-main-nav-bar);
    border-right: 1px solid var(--bg-main-nav-bar);
    padding: 7px !important;
    margin-bottom: 5px;
    max-width: max-content;
}

.sa-badge:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
    background-color: rgba(255, 255, 255, 0.651);
}

.ft-active-selected {
    transform: translateY(-1px);
    box-shadow: 0 2px 10px rgba(63, 63, 63, 0.2);
    border: 1px solid var(--bg-sidebar-item) !important;
    border-color: var(--bg-sidebar-item) !important;
    background-color: var(--bg-button-press-color);
}

.ft-active-class {
    transform: translateY(-1px);
    box-shadow: 0 2px 10px rgba(63, 63, 63, 0.2);
    border: 1px solid var(--bg-sidebar) !important;
    border-color: var(--bg-sidebar) !important;
    background-color: var(--bg-button-press-color);
}

.ft-active-class:hover {
    box-shadow: 0 2px 10px rgba(63, 63, 63, 0.2);
    border: 1px solid var(--bg-sidebar) !important;
    border-color: var(--bg-sidebar) !important;
    background-color: var(--bg-button-press-color);
}

.ft-draggable-block {
    cursor: grab;
}

.ft-draggable-block:active {
    cursor: grabbing;
}
</style>
